import styled, { css } from 'styled-components/macro';

export const Input = styled.input`
  position: absolute;
  z-index: -100;
  opacity: 0;
`;

export const Slider = styled.div.attrs({
  // className: 'checkbox-slider',
})<{ withoutToggleAnimation?: boolean }>`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  border-radius: 34px;

  ${(props) =>
    !props.withoutToggleAnimation &&
    css`
      -webkit-transition: 0.4s;
      transition: 0.4s;

      &:before {
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
    `}

  &:before {
    position: absolute;
    content: '';
    bottom: 2px;
    background-color: white;
    border-radius: 50%;
  }
`;

export const Switch = styled.label.attrs({
  // className: 'checkbox-switch',
})<{
  variant: 'green' | 'blue';
  size?: 'small' | 'medium';
  disabled: boolean;
}>`
  position: relative;
  display: inline-block;
  width: ${(props) => (props.size === 'small' ? '32' : '44')}px;
  height: ${(props) => (props.size === 'small' ? '20' : '24')}px;
  outline: none;

  ${Slider}:before {
    height: ${(props) => (props.size === 'small' ? '16' : '20')}px;
    width: ${(props) => (props.size === 'small' ? '16' : '20')}px;
    left: ${(props) => (props.size === 'small' ? '2' : '3')}px;
  }

  ${Input}:checked + ${Slider} {
    background-color: ${(props) =>
      props.variant === 'green' ? '#27AE60' : '#2D67D8'};
    opacity: ${(props) => (props.disabled ? '0.33' : '1')};
  }

  ${Input}:checked + ${Slider}:before {
    transform: translateX(
      ${(props) => (props.size === 'small' ? '12' : '18')}px
    );
  }

  ${Input}:disabled + ${Slider} {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const Dot = styled.div<{ variant: 'green' | 'blue' }>`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
  border: 1px solid #9da6b4; //#dcdcdc;

  &:before {
    position: absolute;
    content: '';
    height: 10px; //16px;
    width: 10px; //16px;
    left: 2px; //3px;
    bottom: 2px; //3px;
    //background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
`;

export const Round = styled.label<{ variant: 'green' | 'blue' }>`
  position: relative;
  display: inline-block;
  width: 16px; //24px;
  height: 16px; //24px;
  outline: none;

  ${Input}:checked + ${Dot} {
    border: 1px solid
      ${(props) => (props.variant === 'green' ? '#27AE60' : '#2D67D8')};
  }

  ${Input}:checked + ${Dot}:before {
    background-color: ${(props) =>
      props.variant === 'green' ? '#27AE60' : '#2D67D8'};
  }
`;
